import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { User } from '../models/auth/user';
import { Profile } from '../features/auth/profile-management/models/Profile';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  menuLoaded = new BehaviorSubject<any>(false);
  generalRefreshDetails = new BehaviorSubject<boolean>(false);

  public currentUserSubject: BehaviorSubject<User | null> = new BehaviorSubject<User | null>(null);

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    const authLS = localStorage.getItem('authUser');
    const ls = authLS ? JSON.parse(authLS) as User : '';
    if (ls) {
      this.currentUserSubject.next(ls);
    }
  }

  public get currentUserValue(): User | null {
    return this.currentUserSubject.value;
  }

  login(email: string, password: string): any {
    return this.http.post<any>(
      `${environment.apiUrl}/Authenticate/login`,
      { email, password })
      .pipe(map(user => {
        this.currentUserSubject.next(user);
        localStorage.setItem('authUser', JSON.stringify(user));
        return user;
      }));
  }
  logout() {
    this.clearUserData();
    this.router.navigate(['/login']);
  }
  clearUserData() {
    localStorage.removeItem('authUser');
    localStorage.removeItem('baseRoute');
    this.currentUserSubject.next(null);
  }

  forgetPassword(email: string): any {
    return this.http.get(`${environment.apiUrl}/Authenticate/ForgetPassword?email=` + email);
  }
  VerifyResetToken(userId: string, token: string) {
    return this.http.post(`${environment.apiUrl}/Authenticate/VerifyResetToken`, { userId, token });
  }
  resetPassword(userId: string, token: string, newPassword: string, firstTime: boolean) {
    if (firstTime) {
      return this.http.post(`${environment.apiUrl}/Authenticate/FirstTimePassword`, { userId, token, newPassword });
    } else {
      return this.http.post(`${environment.apiUrl}/Authenticate/ResetPassword`, { userId, token, newPassword });
    }
  }
  ChangePassword(oldPassword: string, newPassword: string) {
    return this.http.post(`${environment.apiUrl}/Authenticate/ChangePassword`, { oldPassword, newPassword });
  }
  checkResetPasswordLink(userId: string, token: string) {
    return this.http.post(`${environment.apiUrl}/Authenticate/VerifyToken`, { userId, token });
  }
  ConfirmAccount(userId: string, token: string) {
    return this.http.post(`${environment.apiUrl}/Authenticate/ConfirmAccount`, { userId, token });
  }

  // GetUserDetails() {
  //   const user = this.currentUserValue || new User();
  //   this.http.get(`${environment.apiUrl}/Account/DiwanUserProfile`).subscribe((data: any) => {
  //     user.email = data.userEmail;
  //     user.fullName = data.fullName;
  //     user.id = data.userId;
  //     user.profilePicture = data.userImage;
  //     localStorage.setItem('authUser', JSON.stringify(user));
  //     setTimeout(() => {
  //       location.reload();
  //     }, 100);
  //   }, error => {
  //     this.logout();
  //   });
  // }
  RefeshUserToken() {
    return this.http.post<any>(
      `${environment.apiUrl}/Authenticate/refresh-token`, {})
      .pipe(map(returnUser => {
        const user = this.currentUserValue || new User();
        user.token = returnUser.token;
        this.currentUserSubject.next(returnUser);
        localStorage.setItem('authUser', JSON.stringify(user));
        location.reload();
      }));

  }
  checkUniqueEmail(email: string, isProfile = false) {
    if (isProfile) {
      return this.http.get(`${environment.apiUrl}/User/IsEmailExist?email=` + email + '&isProfile=' + isProfile);
    } else {
      return this.http.get(`${environment.apiUrl}/User/IsEmailExist?email=` + email);
    }
  }
  RegisterUser(obj: object): any {
    return this.http.post(`${environment.apiUrl}/User/RegisterUser`, obj);
  }

  GetDiwanUsersList() {
    return this.http.get(`${environment.apiUrl}/Account/GetDiwanUsersList`);
  }
  GetUserDetails() {
    return this.http.get<Profile>(`${environment.apiUrl}/Account/DiwanUserProfile`);
  }
  updateUserProfile(data: any, photo: any) {
    const formData = new FormData();
    if (photo && photo.name) {
      formData.append('photo', photo, photo.name);
    }
    formData.append('data', JSON.stringify(data));
    return this.http.post(`${environment.apiUrl}/Account/EditDiwanUserProfile`, formData);
  }
}
